import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { withAnalyticsEvents } from '@atlaskit/analytics-next';
import AkIconCheck from '@atlaskit/icon/glyph/check';
import { FilterClickedEvent } from '@atlassian/mpac-analytics';
import { LinkUtils } from '@atlassian/mpac-utils';
import ImmutablePropTypes from '@atlassian/react-immutable-proptypes';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import CommonPropTypes from "../../../../../../../common/constants/proptypes/CommonPropTypes";
import { ANALYTICS_SUBJECT_ID_SIDEBAR_FACET_FILTER, EVENT_CHANNEL, EVENT_SOURCE, OBJECT_TYPE_FILTER } from "../../../../../../constants/analytics/events";
import AddonDiscoveryPropTypes from "../../../../../../constants/proptypes/AddonDiscoveryPropTypes";
import { FacetSidebarItemContainer, Label, TickIcon } from "../../FacetSidebarItem";

var ConjunctiveFacetProduct = /*#__PURE__*/function (_Component) {
  _inherits(ConjunctiveFacetProduct, _Component);

  var _super = _createSuper(ConjunctiveFacetProduct);

  function ConjunctiveFacetProduct() {
    var _this;

    _classCallCheck(this, ConjunctiveFacetProduct);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "onClick", function (event, options) {
      var facetKey = _this.props.facet.get('key');

      var filterValue = _this.props.facetProduct.get('value');

      var newIsSelected = !_this.props.selected;

      _this.props.createAnalyticsEvent({
        eventType: FilterClickedEvent,
        actionSubjectId: ANALYTICS_SUBJECT_ID_SIDEBAR_FACET_FILTER,
        objectType: OBJECT_TYPE_FILTER,
        objectId: facetKey,
        label: _this.props.facetProduct.get('label'),
        parentLabel: _this.props.facet.get('sidebarLabel'),
        source: EVENT_SOURCE,
        attributes: {
          currentPerspective: _this.props.perspective,
          filterValue: filterValue,
          selected: newIsSelected
        }
      }).fire(EVENT_CHANNEL);

      LinkUtils.maybeOpenInNewTab(event, function () {
        _this.props.stateChangeRequested({
          perspective: options.newPerspective,
          filters: options.newFilters
        });
      });
    });

    return _this;
  }

  _createClass(ConjunctiveFacetProduct, [{
    key: "render",
    value: function render() {
      var FiltersLink = this.props.filtersLink;
      var newFilters = this.props.selected ? this.props.filters.delete(this.props.facet.get('key')) : this.props.filters.set(this.props.facet.get('key'), this.props.facetProduct.get('value'));
      return /*#__PURE__*/React.createElement(FacetSidebarItemContainer, {
        selected: this.props.selected
      }, /*#__PURE__*/React.createElement(FiltersLink, {
        className: "ui-product",
        filtersContext: this.props.filtersContext,
        newFilters: newFilters,
        onClick: this.onClick
      }, /*#__PURE__*/React.createElement(TickIcon, null, /*#__PURE__*/React.createElement(AkIconCheck, {
        label: "Selected",
        size: "medium"
      })), /*#__PURE__*/React.createElement(Label, null, /*#__PURE__*/React.createElement("span", null, this.props.facetProduct.get('label')))));
    }
  }]);

  return ConjunctiveFacetProduct;
}(Component);

_defineProperty(ConjunctiveFacetProduct, "propTypes", {
  createAnalyticsEvent: PropTypes.func.isRequired,
  facet: AddonDiscoveryPropTypes.processedFacet.isRequired,
  facetProduct: ImmutablePropTypes.map.isRequired,
  filters: CommonPropTypes.filters.isRequired,
  filtersContext: AddonDiscoveryPropTypes.filtersContext,
  filtersLink: PropTypes.func.isRequired,
  selected: PropTypes.bool.isRequired,
  perspective: AddonDiscoveryPropTypes.perspective.isRequired,
  stateChangeRequested: PropTypes.func.isRequired
});

export default withAnalyticsEvents()(ConjunctiveFacetProduct);